import merch1 from '../../assets/media/merch/merch-1.jpeg';
import merch2 from '../../assets/media/merch/merch-2.jpeg';
import merch3 from '../../assets/media/merch/merch-3.jpeg';
import merch4 from '../../assets/media/merch/merch-4.jpeg';
import merch5 from '../../assets/media/merch/merch-5.jpg';
import merch6 from '../../assets/media/merch/merch-6.jpg';
import merch7 from '../../assets/media/merch/merch-7.jpg';
import merch8 from '../../assets/media/merch/merch-8.jpg';
import merch9 from '../../assets/media/merch/merch-9.jpg';
import merch10 from '../../assets/media/merch/merch-10.jpg';
import merch11 from '../../assets/media/merch/merch-11.jpg';
import merch12 from '../../assets/media/merch/merch-12.jpg';
import merch13 from '../../assets/media/merch/merch-13.jpg';
import merch14 from '../../assets/media/merch/merch-14.jpg';
import merch15 from '../../assets/media/merch/merch-15.jpg';
import merch16 from '../../assets/media/merch/merch-16.jpg';
import merch17 from '../../assets/media/merch/merch-17.jpg';
import merch18 from '../../assets/media/merch/merch-18.jpg';
import merch19 from '../../assets/media/merch/merch-19.jpg';
import merch20 from '../../assets/media/merch/merch-20.jpg';
import merchIcon1 from '../../assets/media/merch/merch-icon-1.png';
import merchIcon2 from '../../assets/media/merch/merch-icon-2.png';
import merchIcon3 from '../../assets/media/merch/merch-icon-3.png';
import merchIcon4 from '../../assets/media/merch/merch-icon-4.png';
import merchIcon5 from '../../assets/media/merch/merch-icon-5.png';
import merchIcon6 from '../../assets/media/merch/merch-icon-6.png';
import merchIcon7 from '../../assets/media/merch/merch-icon-7.png';
import merchIcon8 from '../../assets/media/merch/merch-icon-8.png';
import merchIcon9 from '../../assets/media/merch/merch-icon-9.png';
import merchIcon10 from '../../assets/media/merch/merch-icon-10.png';
import merchIcon11 from '../../assets/media/merch/merch-icon-11.png';
import merchIcon12 from '../../assets/media/merch/merch-icon-12.png';
import merchIcon13 from '../../assets/media/merch/merch-icon-13.png';
import merchIcon14 from '../../assets/media/merch/merch-icon-14.png';
import merchIcon15 from '../../assets/media/merch/merch-icon-15.png';
import merchIcon16 from '../../assets/media/merch/merch-icon-16.png';
import merchIcon17 from '../../assets/media/merch/merch-icon-17.png';
import merchIcon18 from '../../assets/media/merch/merch-icon-18.png';
import merchIcon19 from '../../assets/media/merch/merch-icon-19.png';
import merchIcon20 from '../../assets/media/merch/merch-icon-20.png';
import { merchFilter } from '../types/enums';

const merch: Imerch[] = [
  // {
  //   id: 1,
  //   image: merch1,
  //   icon: merchIcon1,
  //   name: 'ПАНАМА SANTO STEFANO',
  //   descr: 'Легкая панама Santo Stefano с широкими полями и кантом из короткой бахромы. Благодаря аккуратной классической форме и универсальному цвету она легко сочетается с любыми элементами вашего гардероба. Perfetto!',
  //   price: 300,
  //   tag: merchFilter.MAIN,
  //   // discount: 4000
  // },
  // {
  //   id: 2,
  //   image: merch2,
  //   icon: merchIcon2,
  //   name: 'ХУДИ SANTO STEFANO',
  //   descr: 'Худи Santo Stefano с мягкой ворсистой изнанкой обеспечивает комфорт и тепло в любое время года. Универсальный пастельный оттенок и элегантный дизайн позволяют его легко сочетать с любыми элементами повседневного гардероба. Perfetto!<br /><br />Длина по спинке:  64 см<br />Обхват груди: 144 см<br />Длина рукава: 83 см',
  //   price: 600,
  //   tag: merchFilter.MAIN,
  // },
  // {
  //   id: 3,
  //   image: merch3,
  //   icon: merchIcon3,
  //   name: 'СУМКА SANTO STEFANO',
  //   descr: 'Голографический шоппер Santo Stefano станет незаменимым аксессуаром для города, путешествий или спортивных занятий. В разном освещении сумка раскрывает новые, неповторимые оттенки, добавляя вашему образу динамичности. Элегантные ручки цвета шампань придают ей изысканности и комфорта в использовании. Bellissimo!',
  //   price: 400,
  //   tag: merchFilter.MAIN,
  //   // discount: 4000
  // },
  // {
  //   id: 4,
  //   image: merch4,
  //   icon: merchIcon4,
  //   name: 'БАНДАНА SANTO STEFANO',
  //   descr: 'Бандана Santo Stefano - это современный и стильный аксессуар для повседневных образов. Идеально подойдет как для прогулки по городу, так и для смелого решения на вечерний выход. Bellissimo!<br /><br />Размер: 60x60 см<br />Материал: 85% полиэстер и 15% вискоза',
  //   price: 150,
  //   tag: merchFilter.MAIN,
  //   // discount: 4000
  // },
  // {
  //   id: 5,
  //   image: merch5,
  //   icon: merchIcon5,
  //   name: 'СВИТШОТ SANTO STEFANO',
  //   descr: 'Стильный свитшот Santo Stefano - манифест хорошего настроения. Петельная текстура без начеса дарит свободные ощущения, а принт говорит сам за себя: пить Santo Stefano – значит быть счастливым!<br /><br />Длина по спине: 71 см<br />Обхват груди: 63 см<br />Длина рукава: 60 см',
  //   price: 500,
  //   tag: merchFilter.NEW_MERCH,
  //   // discount: 1000
  // },
  // {
  //   id: 6,
  //   image: merch6,
  //   icon: merchIcon6,
  //   name: 'СТИКЕРПАК BIANCO',
  //   descr: 'Яркие стикеры, посвященные коллекции Zero. Укрась ими свой ноутбук, телефон или блокнот и поднимай настроение себе и окружающим!',
  //   price: 200,
  //   tag: merchFilter.MAIN,
  //   sort: 3
  // },
  // {
  //   id: 7,
  //   image: merch7,
  //   icon: merchIcon7,
  //   name: `СВИТШОТ I DON'T NEED A MAN...`,
  //   descr: `"I don't need a man, I need… Santo Stefano."<br />Зачем искать «идеального», если Santo Stefano всегда рядом? Мягкий, уютный и стильный свитшот согреет в любое время года.<br /><br />Длина по спине: 71 см<br />Обхват груди: 63 см<br />Длина рукава: 60 см`,
  //   price: 800,
  //   tag: merchFilter.NEW_MERCH
  // },
  // {
  //   id: 8,
  //   image: merch8,
  //   icon: merchIcon8,
  //   name: 'СВИТШОТ ONCE SANTO STEFANO',
  //   descr: `"Once Santo Stefano, always Santo Stefano."<br />Этот свитшот говорит сам за себя: однажды Santo Stefano, всегда Santo Stefano! Мягкий, уютный и стильный свитшот согреет в любое время года.<br /><br />Длина по спине: 71 см<br />Обхват груди: 63 см<br />Длина рукава: 60 см`,
  //   price: 800,
  //   tag: merchFilter.NEW_MERCH
  // },
  // {
  //   id: 9,
  //   image: merch9,
  //   icon: merchIcon9,
  //   name: 'СВЕЧА SANTO STEFANO CASA - TOSCANA',
  //   descr: 'Тоскана – это место, где время словно растекается по склонам холмов, замедляется, становясь мягче и теплее. Солнце встаёт медленно, его свет ложится на землю словно янтарная вуаль. Аромат спелых фруктов, диких трав и ветра, принесенного с моря, наполняет воздух. Здесь нет спешки, нет суеты — только бесконечный ритм жизни, который напоминает, что всё должно идти своим чередом.<br /><br />Наслаждайтесь простыми радостями и зажигайте по-итальянски вместе с Santo Stefano!<br /><br />Объем: 250 мл<br />Состав: кокосовый воск, ароматические масла, хлопковый фитиль<br />Время непрерывного горения: 48 часов',
  //   price: 730,
  //   tag: merchFilter.NEW_MERCH,
  //   sort: 5
  // },
  // {
  //   id: 10,
  //   image: merch10,
  //   icon: merchIcon10,
  //   name: 'БОКАЛ SANTO STEFANO',
  //   descr: 'Пластиковый бокал формы Flute идеально подходит для игристых вин и коктейлей. Лаконичный и элегантный — такой, каким и должен быть бокал Santo Stefano. Наполните его праздником по-итальянски и подарите себе и своим близким немного яркости и позитива!<br />Объем: 170 мл',
  //   price: 500,
  //   tag: merchFilter.NEW_MERCH,
  //   sort: 6
  // },
  // {
  //   id: 11,
  //   image: merch11,
  //   icon: merchIcon11,
  //   name: 'СТИКЕРПАК ROSSO',
  //   descr: 'Яркие стикеры, посвященные коллекции Zero. Укрась ими свой ноутбук, телефон или блокнот. Поднимай настроение себе и окружающим!',
  //   price: 200,
  //   tag: merchFilter.NEW_MERCH,
  //   sort: 4
  // },
  // {
  //   id: 12,
  //   image: merch12,
  //   icon: merchIcon12,
  //   name: 'Футболка Santo Stefano "CRUSH" (M)',
  //   descr: 'My crush? Always Santo Stefano!<br /> Футболка CRUSH — маленький знак нашей любви к вам.<br /><br /> Состав: 92% хлопок, 8% эластан.<br /> Размер М:<br /> Длина по спине — 75 см<br /> Обхват груди — 62 см<br /> Длина рукава — 22,5 см',
  //   price: 800,
  //   tag: merchFilter.NEW_MERCH,
  //   sort: 2
  // },
  // {
  //   id: 13,
  //   image: merch13,
  //   icon: merchIcon13,
  //   name: 'Футболка Santo Stefano "CRUSH" (L)',
  //   descr: 'My crush? Always Santo Stefano!<br /> Футболка CRUSH — маленький знак нашей любви к вам.<br /><br /> Состав: 92% хлопок, 8% эластан.<br /> Размер L:<br /> Длина по спине — 77 см<br /> Обхват груди — 64 см<br /> Длина рукава — 22,5 см',
  //   price: 800,
  //   tag: merchFilter.NEW_MERCH,
  //   sort: 2
  // },
  // {
  //   id: 14,
  //   image: merch14,
  //   icon: merchIcon14,
  //   name: 'Наклейки для клавиатуры "L\'Aperitivo" (Apple)',
  //   descr: 'Создайте свой маленький бар на клавиатуре!<br /> Легендарные аперитивы Bianco, Aperini, Rosato — теперь не только в ваших бокалах, но и на ваших клавишах.<br /><br /> Миксуйте настроение, печатайте и договаривайтесь о вечеринках по-итальянски!<br /><br /> Размеры и расположение наклеек могут немного отличаться от вашей клавиатуры — каждая клавиатура уникальна, как и вы!',
  //   price: 160,
  //   tag: merchFilter.NEW_MERCH,
  //   sort: 1
  // },
  // {
  //   id: 15,
  //   image: merch15,
  //   icon: merchIcon15,
  //   name: 'Наклейки для клавиатуры "L\'Aperitivo" (Windows)',
  //   descr: 'Создайте свой маленький бар на клавиатуре!<br /> Легендарные аперитивы Bianco, Aperini, Rosato — теперь не только в ваших бокалах, но и на ваших клавишах.<br /><br /> Миксуйте настроение, печатайте и договаривайтесь о вечеринках по-итальянски!<br /><br /> Размеры и расположение наклеек могут немного отличаться от вашей клавиатуры — каждая клавиатура уникальна, как и вы!',
  //   price: 160,
  //   tag: merchFilter.NEW_MERCH,
  //   sort: 1
  // },
  // {
  //   id: 16,
  //   image: merch16,
  //   icon: merchIcon16,
  //   name: 'Сумка Santo Stefano «L\'Aperitivo»',
  //   descr: 'Легкая и вместительная сумка с ярким принтом, который говорит за тебя: ты умеешь отдыхать красиво 💃🍹<br/><br/>  Цвет ручек: желтый, голубой, синий, красный, зеленый.<br/> Материал – силикон<br/> Высота – 31 см<br/> Ширина – 37 см<br/> Глубина – 14 см<br/><br/> *В заказе может попасться сумка с ручками любого из представленных цветов',
  //   price: 400,
  //   tag: merchFilter.NEW_MERCH,
  //   sort: 0
  // },
  // {
  //   id: 17,
  //   image: merch17,
  //   icon: merchIcon17,
  //   name: 'Подушка Santo Stefano',
  //   descr: 'Мягкая подушка с принтом в духе L\'Aperitivo Santo Stefano.<br/> Размер: 30x30',
  //   price: 930,
  //   tag: merchFilter.NEW_MERCH,
  //   sort: 1
  // },
  // {
  //   id: 18,
  //   image: merch18,
  //   icon: merchIcon18,
  //   name: 'Очки Santo Stefano',
  //   descr: 'Стильные солнцезащитные очки. Идеальны для тех, кто любит лето и яркие моменты.',
  //   price: 460,
  //   tag: merchFilter.NEW_MERCH,
  //   sort: 1
  // },
  //   {
  //   id: 19,
  //   image: merch19,
  //   icon: merchIcon19,
  //   name: 'Значки Santo Stefano',
  //   descr: 'Коллекционные значки Santo Stefano. Носите настроение Santo Stefano с собой.<br/> Количество: 3 шт.',
  //   price: 320,
  //   tag: merchFilter.NEW_MERCH,
  //   sort: 1
  // },
  //   {
  //   id: 20,
  //   image: merch20,
  //   icon: merchIcon20,
  //   name: 'Стикерпак Santo Stefano Zero',
  //   descr: 'Стикеры Santo Stefano Zero — маленькие символы радости, которые можно носить с собой.',
  //   price: 100,
  //   tag: merchFilter.NEW_MERCH,
  //   sort: 1
  // },
];

export default merch;